import { Form, Formik, Field } from "formik";
import * as React from "react";

//ICONS
import { HiOutlineCamera } from "react-icons/hi";
import { Loader } from "../../Loader";

interface Values {
  image: string;
}

interface Props {
  onSubmit: (values: Values) => void;
  setImageUrlPlayer: React.SetStateAction<any>;
  update: any;
  isLoading: boolean;
}

export const AddGalleryForm: React.FC<Props> = ({
  onSubmit,
  setImageUrlPlayer,
  update,
  isLoading,
}) => {
  const [picturePreview, setPicturePreview] =
    React.useState<React.SetStateAction<any>>();
  const inputPicture = React.useRef<any>();
  const [file, setFile] = React.useState();
  const [fileObj, setFileObj] = React.useState([]);
  const [fileArray, setFileArray] = React.useState();

  const handleInputPictureForm = (e: React.FormEvent<HTMLInputElement>) => {
    e.stopPropagation();
    e.preventDefault();
    const result = (e.target as HTMLInputElement).files;

    if (result![0].size < 1e6) {
      setImageUrlPlayer(result![0]);

      var file = result![0];
      setPicturePreview(URL?.createObjectURL(file));
    }
  };

  const removeImage = () => {
    setImageUrlPlayer(null);
    setPicturePreview(null);
  };
  const handleInputPictureClick = () => {
    inputPicture.current?.click();
  };

  React.useEffect(() => {
    console.log("picturePreview", picturePreview);
  }, [picturePreview]);
  if (!isLoading)
    return (
      <Formik
        initialValues={{
          image: "",
        }}
        onSubmit={(values, { resetForm }) => {
          onSubmit(values);
          update();
          resetForm();
        }}
      >
        {({ values, isSubmitting }) => (
          <Form>
            <div className="flex flex-col justify-between space-y-4 my-4">
              {picturePreview && (
                <div
                  onClick={removeImage}
                  className="flex flex-col  filter hover:brightness-110 transition duration-150 transform hover:scale-105 cursor-pointer  p-4 animate__animated animate__slideInDown "
                >
                  <img
                    className="h-40 w-40  object-cover -mb-4  "
                    src={picturePreview}
                    alt={picturePreview}
                    onError={({ currentTarget }) => {
                      currentTarget.onerror = null;
                    }}
                  />
                </div>
              )}
              <div
                className="btn btn-circle opacity-80 cursor-pointer absolute right-2"
                onClick={() => handleInputPictureClick()}
              >
                <HiOutlineCamera />
                <input
                  ref={inputPicture}
                  type="file"
                  placeholder="Open a image"
                  accept="image/png, image/jpeg, image/gif*"
                  className="hidden"
                  name="image"
                  multiple
                  onChange={handleInputPictureForm}
                />
              </div>
            </div>

            {picturePreview !== null && picturePreview !== undefined && (
              <button  className="flex items-center bg-lime-400 hover:bg-lime-500 px-4 py-2 rounded-lg shadow-lg transition-all transform duration-200 ease-in-out " disabled={isSubmitting} type="submit">
                Añadir Imagen
              </button>
            )}
          </Form>
        )}
      </Formik>
    );
  else {
    return <Loader />;
  }
};
